import {httpClient} from '@/main';

export const fetchCriteriaOptimizationList = (id: number) =>
    httpClient.get('planRes/getCriteriaOptimizationList', {
        params: {
            id,
        },
    });
